import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { CampaignService } from 'src/app/services/campaign.service';
import { CAMPAIGN_TYPE } from '../campaign-type-dropdown/campaign-type-dropdown.constant';

@Component({
    selector: 'app-campaign-header',
    templateUrl: './campaign-header.component.html',
    styleUrls: ['./campaign-header.component.scss'],
    standalone: true,
    imports: [FlexModule, NgClass, ExtendedModule, TourAnchorMatMenuDirective, RouterLink]
})
export class CampaignHeaderComponent {
  private router = inject(Router);
  private campaignService = inject(CampaignService);
  @Input() stats?: any;
  @Input() heading: string | undefined;
  @Input() headingIcon: string | undefined;
  @Input() subHeading: string | undefined;
  @Input() subHeadingIcon: string | undefined;
  @Input() isScoreBoard: boolean = false;
  @Input() totalSuppliers?: number;
  @Input() newSuppliers?: number;
  @Input() existingSuppliers?: number;
  @Input() needsResolution?: number;
  @Input() isValidated?: boolean;
  @Input() campaignDetails?: any;
  @Input() campaignType?: CAMPAIGN_TYPE = CAMPAIGN_TYPE.Organization;
  @Input() totalUsers?: number;
  @Input() newUsers?: number;
  @Input() existingUsers?: number;
  @Input() campaignId?: string = '';
  @Input() campaignName?: string = '';
  @Input() shouldGotoActions?: boolean = true;
  @Input() isDataCorrections?: boolean = false;
  @Output() nextButtonAction = new EventEmitter<any>();
  
  isShowCuration:boolean = false;
  isShowAction:boolean = false;
  CAMPAIGN_TYPE = CAMPAIGN_TYPE;
  @Output() startCampaignEmit = new EventEmitter<void>();
  constructor() {
    
    let currentPath = this.router.url;
    if(currentPath == "/campaign/validate" || currentPath == "/campaign/validate-user") {
      this.isShowCuration = true;
      this.isShowAction = false;
    } else if(currentPath == "/campaign/actions") {
      this.isShowAction = true;
      this.isShowCuration = false;
    }
  }
  ngOnInit()
  {
   
  }
  goToActions() {
    if(!this.shouldGotoActions) {
      this.nextButtonAction?.emit();
    } else {

    if(this.campaignType === CAMPAIGN_TYPE.Organization) {
      this.router.navigate(['/campaign/actions'], { state: { data: this.campaignDetails, currentSelectedCampaignType: CAMPAIGN_TYPE.Organization, campaignId: this.campaignId, campaignName: this.campaignName } });
    } else {
      this.campaignService.bulkLoadUserUpdateCampaignStatus(this.campaignId || '').subscribe(() => {
        this.router.navigate(['/campaign/actions'], { state: { data: this.campaignDetails, currentSelectedCampaignType: CAMPAIGN_TYPE.User, campaignId: this.campaignId, campaignName: this.campaignName } });
      })
    }
  }
  }
  startToCampaign() {
    this.startCampaignEmit.emit();
  }
}
